import { ACTIONS, SCAFFOLD } from 'a/pictureThis/data/constants';

export const initialState = {
  helpCount: 0,
  triesCount: 0,
  triesCountOnCurrentElement: 0,
  isScaffold: false,
};

const currentItem = (state = initialState, { type }) => {
  switch (type) {
    case ACTIONS.ADVANCE_CONTENT:
    case ACTIONS.SELECT_LEVEL:
    case ACTIONS.FINISH_SCAFFOLD:
      return initialState;

    case ACTIONS.COLLECT_ELEMENT:
      return {
        ...state,
        triesCountOnCurrentElement: 0,
      };

    case 'INCREASE_HELP_COUNTER':
      return {
        ...state,
        helpCount: state.helpCount + 1,
      };

    case ACTIONS.INCREASE_WRONG_STEP:
      return {
        ...state,
        triesCount: state.triesCount + 1,
        triesCountOnCurrentElement: state.triesCountOnCurrentElement + 1,
        isScaffold: state.triesCount + 1 >= SCAFFOLD.THRESHOLD,
      };

    default:
      return state;
  }
};

export default currentItem;

export const getIsScaffold = state => state.isScaffold;

export const getHelpCount = state => state.helpCount;

export const getTriesCount = state => state.triesCount;

export const getTriesCountOnCurrentElement = state => state.triesCountOnCurrentElement;
